/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
import {
    AsyncResult,
    callActionOrExecute,
    DataServiceQuery,
    IContext,
    IDataServiceRequest,
    IQueryResultSettings
} from '@msdyn365-commerce/retail-proxy';
//import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';
import * as Entities from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceTypes.g';
import * as DataServiceEntities from './DataServiceEntities.g';

// @ts-ignore
function customResponse_CAPQuery(id?: string): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('CustomResponse_CAP', 'CustomResponse_CAP', DataServiceEntities.CustomResponse_CAPExtensionClass, key);
}

export function createInsertBackInStock_CAPInput(
    queryResultSettings: IQueryResultSettings,
    channel: number,
    customerAccount: string,
    itemId: string,
    color: string,
    configuration: string,
    size: string,
    style: string,
    qty: number
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'InsertBackInStock_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        {
            Channel: channel,
            CustomerAccount: customerAccount,
            ItemId: itemId,
            Color: color,
            Configuration: configuration,
            Size: size,
            Style: style,
            Qty: qty
        }
    );
}

export function createInsertBackInStock_CAPInput_v2(
    queryResultSettings: IQueryResultSettings,
    channel: number,
    customerAccount: string,
    itemId: string,
    color: string,
    configuration: string,
    size: string,
    style: string,
    qty: number,
    email: string,
    language: string
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'InsertBackInStock_CAP_V2',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        {
            Channel: channel,
            CustomerAccount: customerAccount,
            ItemId: itemId,
            Color: color,
            Configuration: configuration,
            Size: size,
            Style: style,
            Qty: qty,
            Email: email,
            Language: language
        }
    );
}

export function insertBackInStock_CAPAsync(
    context: IContext,
    channel: number,
    customerAccount: string,
    itemId: string,
    color: string,
    configuration: string,
    size: string,
    style: string,
    qty: number
): AsyncResult<DataServiceEntities.ICustomResponse_CAP[]> {
    const request = createInsertBackInStock_CAPInput(
        context.queryResultSettings || {},
        channel,
        customerAccount,
        itemId,
        color,
        configuration,
        size,
        style,
        qty
    );
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP[]>(request, context.callerContext);
}

export function insertBackInStock_CAPAsync_v2(
    context: IContext,
    channel: number,
    customerAccount: string,
    itemId: string,
    color: string,
    configuration: string,
    size: string,
    style: string,
    qty: number,
    email: string,
    language: string
): AsyncResult<DataServiceEntities.ICustomResponse_CAP[]> {
    const request = createInsertBackInStock_CAPInput_v2(
        context.queryResultSettings || {},
        channel,
        customerAccount,
        itemId,
        color,
        configuration,
        size,
        style,
        qty,
        email,
        language
    );
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP[]>(request, context.callerContext);
}

export function createAddPickAndMixListAsInfocodes_CAPInput(
    queryResultSettings: IQueryResultSettings,
    pickAndMixItems: DataServiceEntities.IICollection_1OfPickAndMixItem_CAP,
    cart: Entities.Cart
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'AddPickAndMixListAsInfocodes_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        { PickAndMixItems: pickAndMixItems, Cart: cart }
    );
}

export function addPickAndMixListAsInfocodes_CAPAsync(
    context: IContext,
    pickAndMixItems: DataServiceEntities.IICollection_1OfPickAndMixItem_CAP,
    cart: Entities.Cart
): AsyncResult<DataServiceEntities.ICustomResponse_CAP[]> {
    const request = createAddPickAndMixListAsInfocodes_CAPInput(context.queryResultSettings || {}, pickAndMixItems, cart);
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP[]>(request, context.callerContext);
}

export function createAddNewCase_CAPInput(
    channel: number,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    category: string,
    subcategory: string,
    title: string,
    text: string
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'AddNewCase_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        {
            Channel: channel,
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            PhoneNumber: phoneNumber,
            Category: category,
            Subcategory: subcategory,
            Title: title,
            Text: text
        }
    );
}

export function addNewCase_CAPAsync(
    context: IContext,
    channel: number,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    category: string,
    subcategory: string,
    title: string,
    text: string
): AsyncResult<DataServiceEntities.ICustomResponse_CAP> {
    const request = createAddNewCase_CAPInput(channel, firstName, lastName, email, phoneNumber, category, subcategory, title, text);
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP>(request, context.callerContext);
}

export function createAddToNewsLetter_CAPInput(
    channel: number,
    email: string,
    genMarketing: boolean,
    thirdParty: boolean
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'AddToNewsLetter_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        {
            Channel: channel,
            Email: email,
            GenMarketing: genMarketing,
            ThirdParty: thirdParty
        }
    );
}

export function addToNewsLetter_CAPAsync(
    context: IContext,
    channel: number,
    email: string,
    genMarketing: boolean,
    thirdParty: boolean
): AsyncResult<DataServiceEntities.ICustomResponse_CAP> {
    const request = createAddToNewsLetter_CAPInput(channel, email, genMarketing, thirdParty);
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP>(request, context.callerContext);
}

export function createAddToNewsLetter_Len_CAPInput(
    channel: number,
    email: string,
    genMarketing: boolean,
    thirdParty: boolean,
    language: string
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'AddToNewsLetter_Len_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        {
            Channel: channel,
            Email: email,
            GenMarketing: genMarketing,
            ThirdParty: thirdParty,
            Language: language
        }
    );
}

export function addToNewsLetter_Len_CAPAsync(
    context: IContext,
    channel: number,
    email: string,
    genMarketing: boolean,
    thirdParty: boolean,
    language: string
): AsyncResult<DataServiceEntities.ICustomResponse_CAP> {
    const request = createAddToNewsLetter_Len_CAPInput(channel, email, genMarketing, thirdParty, language);
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP>(request, context.callerContext);
}

// SIGN UP
export function createSaveMailForPrivacy_CAPInput(
    channel: number,
    email: string,
    firstName: string,
    lastName: string,
    deleteA: boolean
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'SaveMailForPrivacy_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        {
            Channel: channel,
            Email: email,
            FirstName: firstName,
            LastName: lastName,
            Delete: deleteA
        }
    );
}

export function saveMailForPrivacy_CAPAsync(
    context: IContext,
    channel: number,
    email: string,
    firstName: string,
    lastName: string,
    deleteA: boolean
): AsyncResult<DataServiceEntities.ICustomResponse_CAP> {
    const request = createSaveMailForPrivacy_CAPInput(channel, email, firstName, lastName, deleteA);
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP>(request, context.callerContext);
}

// verification email page
export function createAddToNewsLetterWelcomeOffer_CAPInput(channel: number, email: string, token: string): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'AddToNewsLetterWelcomeOffer_CAP',
        true,
        DataServiceEntities.AddCustomerResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IAddCustomerResponse_CAP'
        },
        { Channel: channel, Email: email, Token: token }
    );
}

export function addToNewsLetterWelcomeOffer_CAPAsync(
    context: IContext,
    channel: number,
    email: string,
    token: string
): AsyncResult<DataServiceEntities.IAddCustomerResponse_CAP> {
    const request = createAddToNewsLetterWelcomeOffer_CAPInput(channel, email, token);
    return callActionOrExecute<DataServiceEntities.IAddCustomerResponse_CAP>(request, context.callerContext);
}

// TODO: enable loyalty flow
export function createAddToNewsLetterWelcomeOffer_Len_CAPInput(
    channel: number,
    email: string,
    token: string,
    language: string,
    source: string
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'AddToNewsLetterWelcomeOffer_Len_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        {
            Channel: channel,
            Email: email,
            Token: token,
            Language: language,
            Source: source
        }
    );
}
// TODO: enable loyalty flow
export function addToNewsLetterWelcomeOffer_Len_CAPAsync(
    context: IContext,
    channel: number,
    email: string,
    token: string,
    language: string,
    source: string
): AsyncResult<DataServiceEntities.ICustomResponse_CAP> {
    const request = createAddToNewsLetterWelcomeOffer_Len_CAPInput(channel, email, token, language, source);
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP>(request, context.callerContext);
}

// Nesletter banner subscription
export function createAddToNewsLetterSendMailConfirm_CAPInput(
    channel: number,
    email: string,
    genMarketing: boolean,
    thirdParty: boolean
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'AddToNewsLetterSendMailConfirm_CAP',
        true,
        DataServiceEntities.AddCustomerResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IAddCustomerResponse_CAP'
        },
        {
            Channel: channel,
            Email: email,
            GenMarketing: genMarketing,
            ThirdParty: thirdParty
        }
    );
}

export function addToNewsLetterSendMailConfirm_CAPAsync(
    context: IContext,
    channel: number,
    email: string,
    genMarketing: boolean,
    thirdParty: boolean
): AsyncResult<DataServiceEntities.IAddCustomerResponse_CAP> {
    const request = createAddToNewsLetterSendMailConfirm_CAPInput(channel, email, genMarketing, thirdParty);
    return callActionOrExecute<DataServiceEntities.IAddCustomerResponse_CAP>(request, context.callerContext);
}
// TODO: enable loyalty flow
export function createAddToNewsLetterSendMailConfirm_Len_CAPInput(
    channel: number,
    email: string,
    genMarketing: boolean,
    thirdParty: boolean,
    language: string,
    source: string
): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'AddToNewsLetterSendMailConfirm_Len_CAP',
        true,
        DataServiceEntities.AddCustomerResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.IAddCustomerResponse_CAP'
        },
        {
            Channel: channel,
            Email: email,
            GenMarketing: genMarketing,
            ThirdParty: thirdParty,
            Language: language,
            Source: source
        }
    );
}
// TODO: enable loyalty flow
export function addToNewsLetterSendMailConfirm_Len_CAPAsync(
    context: IContext,
    channel: number,
    email: string,
    genMarketing: boolean,
    thirdParty: boolean,
    language: string,
    source: string
): AsyncResult<DataServiceEntities.IAddCustomerResponse_CAP> {
    const request = createAddToNewsLetterSendMailConfirm_Len_CAPInput(channel, email, genMarketing, thirdParty, language, source);
    return callActionOrExecute<DataServiceEntities.IAddCustomerResponse_CAP>(request, context.callerContext);
}

// CHECKOUT INVOICE
export function createGetInvoiceAccountInfo_CAPInput(accountNum: string): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'GetInvoiceAccountInfo_CAP',
        true,
        DataServiceEntities.InvoiceAccountInfoExtensionClass,
        'false',
        {
            bypassCache: 'none',
            returnEntity: 'DataServiceEntities.IInvoiceAccountInfo'
        },
        { AccountNum: accountNum }
    );
}

export function getInvoiceAccountInfo_CAPAsync(
    context: IContext,
    accountNum: string
): AsyncResult<DataServiceEntities.IInvoiceAccountInfo> {
    const request = createGetInvoiceAccountInfo_CAPInput(accountNum);
    return callActionOrExecute<DataServiceEntities.IInvoiceAccountInfo>(request, context.callerContext);
}

export function createValidateVatNum_CAPInput(vatNum: string, countryRegionId: string): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'ValidateVatNum_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        { VatNum: vatNum, CountryRegionId: countryRegionId }
    );
}

export function validateVatNum_CAPAsync(
    context: IContext,
    vatNum: string,
    countryRegionId: string
): AsyncResult<DataServiceEntities.ICustomResponse_CAP> {
    const request = createValidateVatNum_CAPInput(vatNum, countryRegionId);
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP>(request, context.callerContext);
}

export function createValidateCartForInvoice_CAPInput(cart: Entities.Cart): IDataServiceRequest {
    const query = customResponse_CAPQuery();
    return query.createDataServiceRequestForOperation(
        'ValidateCartForInvoice_CAP',
        true,
        DataServiceEntities.CustomResponse_CAPExtensionClass,
        'false',
        {
            bypassCache: 'get',
            returnEntity: 'DataServiceEntities.ICustomResponse_CAP'
        },
        { Cart: cart }
    );
}

export function validateCartForInvoice_CAPAsync(
    context: IContext,
    cart: Entities.Cart
): AsyncResult<DataServiceEntities.ICustomResponse_CAP> {
    const request = createValidateCartForInvoice_CAPInput(cart);
    return callActionOrExecute<DataServiceEntities.ICustomResponse_CAP>(request, context.callerContext);
}

/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 * THIS FILE IS AN AUTOGENERATED TYPESCRIPT PROXY EXTENSION.
 * TO USE THIS FILE, IT MUST BE ADDED TO A D365COMMERCE APPLICATION
 */
// tslint:disable
// import { NullResult } from '@msdyn365-commerce/retail-proxy';
// @ts-ignore
import * as EntityClasses from '@msdyn365-commerce/retail-proxy/dist/Entities/CommerceModels.g';

function getLoyaltyCard_DLXQuery(): DataServiceQuery {
    return new DataServiceQuery();
}

export function getLoyaltyCard_DLXInput(queryResultSettings: IQueryResultSettings, cardNumber: string, email: string): IDataServiceRequest {
    const query = getLoyaltyCard_DLXQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'GetLoyaltyCard_DLX',
        true,
        EntityClasses.LoyaltyCardClass,
        'true',
        { bypassCache: 'get', returnEntity: 'Entities.LoyaltyCard' },
        {
            CardNumber: cardNumber,
            Email: email
        }
    );
}

export function getLoyaltyCard_DLXAsync(context: IContext, cardNumber: string, email: string): AsyncResult<Entities.LoyaltyCard[]> {
    const request = getLoyaltyCard_DLXInput(context.queryResultSettings || {}, cardNumber, email);
    return callActionOrExecute<Entities.LoyaltyCard[]>(request, context.callerContext);
}

// @ts-ignore
function customResponse_DLXQuery(id?: string): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('CustomResponse_DLX', 'CustomResponse_DLX', DataServiceEntities.CustomResponse_DLXExtensionClass, key);
}

export function createSignUp_DLXInput(
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    issueCard: boolean,
    genMarketing: boolean,
    profiling: boolean,
    thirdParty: boolean,
    language: string,
    birthday: string,
    zipCode: string,
    source: string,
    cRMRegion: string
): IDataServiceRequest {
    const query = customResponse_DLXQuery();
    return query.createDataServiceRequestForOperation(
        'SignUp_DLX',
        true,
        DataServiceEntities.Customer_DLXExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomer_DLX' },
        {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            PhoneNumber: phoneNumber,
            IssueCard: issueCard,
            GenMarketing: genMarketing,
            Profiling: profiling,
            ThirdParty: thirdParty,
            Language: language,
            Birthday: birthday,
            ZipCode: zipCode,
            Source: source,
            CRMRegion: cRMRegion
        }
    );
}

export function signUp_DLXAsync(
    context: IContext,
    firstName: string,
    lastName: string,
    email: string,
    phoneNumber: string,
    issueCard: boolean,
    genMarketing: boolean,
    profiling: boolean,
    thirdParty: boolean,
    language: string,
    birthday: string,
    zipCode: string,
    source: string,
    cRMRegion: string
): AsyncResult<DataServiceEntities.ICustomer_DLX> {
    const request = createSignUp_DLXInput(
        firstName,
        lastName,
        email,
        phoneNumber,
        issueCard,
        genMarketing,
        profiling,
        thirdParty,
        language,
        birthday,
        zipCode,
        source,
        cRMRegion
    );
    console.log("request for signUp_DLXAsync send to CSU", request);
    return callActionOrExecute<DataServiceEntities.ICustomer_DLX>(request, context.callerContext);
}

export function createSignUp_DLX_V2Input(firstName: string, lastName: string, email: string, password: string, phoneNumber: string, issueCard: boolean, genMarketing: boolean, profiling: boolean, thirdParty: boolean, language: string, birthday: string, zipCode: string, source: string, cRMRegion: string): IDataServiceRequest {
    const query = customResponse_DLXQuery();
    return query.createDataServiceRequestForOperation('SignUp_DLX_V2', true, DataServiceEntities.Customer_DLXExtensionClass, 'false', {bypassCache: 'get', returnEntity: 'DataServiceEntities.ICustomer_DLX'}, {FirstName: firstName, LastName: lastName, Email: email, Password: password, PhoneNumber: phoneNumber, IssueCard: issueCard, GenMarketing: genMarketing, Profiling: profiling, ThirdParty: thirdParty, Language: language, Birthday: birthday, ZipCode: zipCode, Source: source, CRMRegion: cRMRegion });
}
    
export function signUp_DLX_V2Async(context: IContext, firstName: string, lastName: string, email: string, password: string, phoneNumber: string, issueCard: boolean, genMarketing: boolean, profiling: boolean, thirdParty: boolean, language: string, birthday: string, zipCode: string, source: string, cRMRegion: string): AsyncResult<DataServiceEntities.ICustomer_DLX> {
    const request = createSignUp_DLX_V2Input(firstName, lastName, email, password, phoneNumber, issueCard, genMarketing, profiling, thirdParty, language, birthday, zipCode, source, cRMRegion);
    console.log("request for SignUp_DLX_V2Async send to CSU", request);
    return callActionOrExecute<DataServiceEntities.ICustomer_DLX>(request, context.callerContext);
}

export function createSignUp_DLX_V3Input(
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    phoneNumber: string,
    issueCard: boolean,
    genMarketing: boolean,
    profiling: boolean,
    thirdParty: boolean,
    language: string,
    birthday: string,
    zipCode: string,
    source: string,
    cRMRegion: string
): IDataServiceRequest {
    const query = customResponse_DLXQuery();
    return query.createDataServiceRequestForOperation(
        'SignUp_DLX_V3',
        true,
        DataServiceEntities.CreateNewsletterCustomerResponse_DLXExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.ICreateNewsletterCustomerResponse_DLX' },
        {
            FirstName: firstName,
            LastName: lastName,
            Email: email,
            Password: password,
            PhoneNumber: phoneNumber,
            IssueCard: issueCard,
            GenMarketing: genMarketing,
            Profiling: profiling,
            ThirdParty: thirdParty,
            Language: language,
            Birthday: birthday,
            ZipCode: zipCode,
            Source: source,
            CRMRegion: cRMRegion
        }
    );
}

export function signUp_DLX_V3Async(
    context: IContext,
    firstName: string,
    lastName: string,
    email: string,
    password: string,
    phoneNumber: string,
    issueCard: boolean,
    genMarketing: boolean,
    profiling: boolean,
    thirdParty: boolean,
    language: string,
    birthday: string,
    zipCode: string,
    source: string,
    cRMRegion: string
): AsyncResult<DataServiceEntities.ICreateNewsletterCustomerResponse_DLX> {
    const request = createSignUp_DLX_V3Input(
        firstName,
        lastName,
        email,
        password,
        phoneNumber,
        issueCard,
        genMarketing,
        profiling,
        thirdParty,
        language,
        birthday,
        zipCode,
        source,
        cRMRegion
    );
    console.log('request for SignUp_DLX_V3 send to CSU', request);
    return callActionOrExecute<DataServiceEntities.ICreateNewsletterCustomerResponse_DLX>(request, context.callerContext);
}

// @ts-ignore
function orgUnitLocationQuery(id?: string): DataServiceQuery {
    const key = id ? { Id: id } : null;
    return new DataServiceQuery('OrgUnitLocation', 'CustomResponse_DLX', DataServiceEntities.CustomResponse_DLXExtensionClass, key);
}

export function createSearchOrgUnitLocations_DLXInput(
    queryResultSettings: IQueryResultSettings,
    searchArea: Entities.SearchArea,
    channelId: number
): IDataServiceRequest {
    const query = orgUnitLocationQuery().resultSettings(queryResultSettings);
    return query.createDataServiceRequestForOperation(
        'SearchOrgUnitLocations_DLX',
        true,
        EntityClasses.OrgUnitLocationClass,
        'true',
        { bypassCache: 'none', returnEntity: 'Entities.OrgUnitLocation' },
        { searchArea: searchArea, ChannelId: channelId }
    );
}

export function searchOrgUnitLocations_DLXAsync(
    context: IContext,
    searchArea: Entities.SearchArea,
    channelId: number
): AsyncResult<Entities.OrgUnitLocation[]> {
    const request = createSearchOrgUnitLocations_DLXInput(context.queryResultSettings || {}, searchArea, channelId);
    return callActionOrExecute<Entities.OrgUnitLocation[]>(request, context.callerContext);
}

export function createAvailableGiftsWithPurchase_DLXInput(cartId: string): IDataServiceRequest {
    const query = customResponse_DLXQuery();
    return query.createDataServiceRequestForOperation(
        'AvailableGiftsWithPurchase_DLX',
        true,
        DataServiceEntities.GiftWithPurchaseApiResponse_DLXExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IGiftWithPurchaseApiResponse_DLX' },
        { cartId: cartId }
    );
}

export function availableGiftsWithPurchase_DLXAsync(
    context: IContext,
    cartId: string
): AsyncResult<DataServiceEntities.IGiftWithPurchaseApiResponse_DLX> {
    const request = createAvailableGiftsWithPurchase_DLXInput(cartId);
    return callActionOrExecute<DataServiceEntities.IGiftWithPurchaseApiResponse_DLX>(request, context.callerContext);
}

///////////////////////////////////////////
////////////////////////////////////
////////// New consent management /////////
///////////////////////////////////
//////////////////////////////////////////

// @ts-ignore
function venchiConsentQuery(key?: number): DataServiceQuery {
    // const key = id ? { Id: id } : null;
    // @ts-ignore
    // eslint-disable-next-line no-redeclare
    const k = key ? { key: key } : null;
    return new DataServiceQuery('VenchiConsent', 'CustomerConsentVenchi', DataServiceEntities.CustomerConsentVenchiExtensionClass, k);
}

export function createGetCustomerConsentsInput(): IDataServiceRequest {
    const query = venchiConsentQuery();

    return query.createDataServiceRequestForOperation(
        'GetCustomerConsents',
        true,
        DataServiceEntities.CustomerConsentVenchiExtensionClass,
        'false',
        { bypassCache: 'none', returnEntity: 'DataServiceEntities.ICustomerConsentVenchi' },
        {}
    );
}

export function getCustomerConsentsAsync(context: IContext): AsyncResult<DataServiceEntities.ICustomerConsentVenchi> {
    const request = createGetCustomerConsentsInput();
    return callActionOrExecute<DataServiceEntities.ICustomerConsentVenchi>(request, context.callerContext);
}

export function createUpdateGenMarketingSmsConsentsInput(isEnabled: boolean): IDataServiceRequest {
    const query = venchiConsentQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateGenMarketingSmsConsents',
        true,
        DataServiceEntities.ConsentUpdateResponseVenchiExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IConsentUpdateResponseVenchi' },
        { isEnabled: isEnabled }
    );
}

export function updateGenMarketingSmsConsentsAsync(
    context: IContext,
    isEnabled: boolean
): AsyncResult<DataServiceEntities.IConsentUpdateResponseVenchi> {
    const request = createUpdateGenMarketingSmsConsentsInput(isEnabled);
    return callActionOrExecute<DataServiceEntities.IConsentUpdateResponseVenchi>(request, context.callerContext);
}

export function createUpdateGenMarketingEmailConsentsInput(isEnabled: boolean): IDataServiceRequest {
    const query = venchiConsentQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateGenMarketingEmailConsents',
        true,
        DataServiceEntities.ConsentUpdateResponseVenchiExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IConsentUpdateResponseVenchi' },
        { isEnabled: isEnabled }
    );
}

export function updateGenMarketingEmailConsentsAsync(
    context: IContext,
    isEnabled: boolean
): AsyncResult<DataServiceEntities.IConsentUpdateResponseVenchi> {
    const request = createUpdateGenMarketingEmailConsentsInput(isEnabled);
    return callActionOrExecute<DataServiceEntities.IConsentUpdateResponseVenchi>(request, context.callerContext);
}

export function createUpdateThirdPartySmsConsentsInput(isEnabled: boolean): IDataServiceRequest {
    const query = venchiConsentQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateThirdPartySmsConsents',
        true,
        DataServiceEntities.ConsentUpdateResponseVenchiExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IConsentUpdateResponseVenchi' },
        { isEnabled: isEnabled }
    );
}

export function updateThirdPartySmsConsentsAsync(
    context: IContext,
    isEnabled: boolean
): AsyncResult<DataServiceEntities.IConsentUpdateResponseVenchi> {
    const request = createUpdateThirdPartySmsConsentsInput(isEnabled);
    return callActionOrExecute<DataServiceEntities.IConsentUpdateResponseVenchi>(request, context.callerContext);
}

export function createUpdateThirdPartyEmailConsentsInput(isEnabled: boolean): IDataServiceRequest {
    const query = venchiConsentQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateThirdPartyEmailConsents',
        true,
        DataServiceEntities.ConsentUpdateResponseVenchiExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IConsentUpdateResponseVenchi' },
        { isEnabled: isEnabled }
    );
}

export function updateThirdPartyEmailConsentsAsync(
    context: IContext,
    isEnabled: boolean
): AsyncResult<DataServiceEntities.IConsentUpdateResponseVenchi> {
    const request = createUpdateThirdPartyEmailConsentsInput(isEnabled);
    return callActionOrExecute<DataServiceEntities.IConsentUpdateResponseVenchi>(request, context.callerContext);
}

export function createUpdateProfilingSmsConsentsInput(isEnabled: boolean): IDataServiceRequest {
    const query = venchiConsentQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateProfilingSmsConsents',
        true,
        DataServiceEntities.ConsentUpdateResponseVenchiExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IConsentUpdateResponseVenchi' },
        { isEnabled: isEnabled }
    );
}

export function updateProfilingSmsConsentsAsync(
    context: IContext,
    isEnabled: boolean
): AsyncResult<DataServiceEntities.IConsentUpdateResponseVenchi> {
    const request = createUpdateProfilingSmsConsentsInput(isEnabled);
    return callActionOrExecute<DataServiceEntities.IConsentUpdateResponseVenchi>(request, context.callerContext);
}

export function createUpdateProfilingEmailConsentsInput(isEnabled: boolean): IDataServiceRequest {
    const query = venchiConsentQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateProfilingEmailConsents',
        true,
        DataServiceEntities.ConsentUpdateResponseVenchiExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IConsentUpdateResponseVenchi' },
        { isEnabled: isEnabled }
    );
}

export function updateProfilingEmailConsentsAsync(
    context: IContext,
    isEnabled: boolean
): AsyncResult<DataServiceEntities.IConsentUpdateResponseVenchi> {
    const request = createUpdateProfilingEmailConsentsInput(isEnabled);
    return callActionOrExecute<DataServiceEntities.IConsentUpdateResponseVenchi>(request, context.callerContext);
}

export function createUpdateConsentsByNameInput(consentName: string, isEnabled: boolean): IDataServiceRequest {
    const query = venchiConsentQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateConsentsByName',
        true,
        DataServiceEntities.ConsentUpdateResponseVenchiExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IConsentUpdateResponseVenchi' },
        { consentName: consentName, isEnabled: isEnabled }
    );
}

export function updateConsentsByNameAsync(
    context: IContext,
    consentName: string,
    isEnabled: boolean
): AsyncResult<DataServiceEntities.IConsentUpdateResponseVenchi> {
    const request = createUpdateConsentsByNameInput(consentName, isEnabled);
    return callActionOrExecute<DataServiceEntities.IConsentUpdateResponseVenchi>(request, context.callerContext);
}

export function createUpdateAllConsentsInput(consents: DataServiceEntities.ICustomerConsentVenchi): IDataServiceRequest {
    const query = venchiConsentQuery();
    return query.createDataServiceRequestForOperation(
        'UpdateAllConsents',
        true,
        DataServiceEntities.ConsentUpdateResponseVenchiExtensionClass,
        'false',
        { bypassCache: 'get', returnEntity: 'DataServiceEntities.IConsentUpdateResponseVenchi' },
        { consents: consents }
    );
}

export function updateAllConsentsAsync(
    context: IContext,
    consents: DataServiceEntities.ICustomerConsentVenchi
): AsyncResult<DataServiceEntities.IConsentUpdateResponseVenchi> {
    const request = createUpdateAllConsentsInput(consents);
    return callActionOrExecute<DataServiceEntities.IConsentUpdateResponseVenchi>(request, context.callerContext);
}
